<app-item-base [open]="open">
  <p class="name" placement="right">
    時間
  </p>

  <div class="edit-field">
    <input class="large-input" type="text" placeholder="駅名" [(ngModel)]="this.searchParams.commute_location" name="commute_location" />
    <input class="large-input" type="text" placeholder="分" [(ngModel)]="this.searchParams.commute_time" name="commute_time" />
  </div>
</app-item-base>
